<template>
  <div class="container orders-page">
    <v-head></v-head>
    <v-left current="abandoned" active="abandoned"></v-left>
    <div>
      <div class="filter-dic clearfix">
        <div class="fl">
          <el-select
            v-model="filter.app_id"
            placeholder="应用"
            size="small"
            class="w160"
            @change="search"
            @clear="search"
            clearable
          >
            <el-option
              v-for="item in $store.state.public.cfg.apps_options"
              :key="item.id"
              :label="item.label"
              :value="item.id"
            ></el-option>
          </el-select>
          <!-- <el-select
            v-model="filter.status"
            placeholder="订单状态"
            clearable
            @clear="search"
            @change="search"
            size="small"
            class="w160"
          >
            <el-option
              v-for="item in $store.state.public.cfg.order_status_options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select> -->
          <el-select
            v-model="filter.order_step"
            placeholder="订单流程"
            clearable
            @clear="search"
            @change="search"
            size="small"
            class="w160"
          >
            <el-option
              v-for="item in order_step_options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <el-date-picker
            size="small"
            style="width: 256px"
            v-model="filter.time_range"
            clearable
            @change="search"
            type="daterange"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            align="right"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerOptions"
          ></el-date-picker>
          <el-input
            size="small"
            v-model="filter.order_no"
            placeholder="订单号"
            clearable
            @clear="search"
            @change="search"
            style="width: 133px"
            class="w400 input-with-select"
          >
          </el-input>
          <el-input
            size="small"
            v-model="filter.shopify_order_number"
            placeholder="Shopify编号"
            clearable
            @clear="search"
            @change="search"
            style="width: 133px"
            class="w400 input-with-select"
          >
          </el-input>
          <el-input
            size="small"
            v-model="filter.keyword"
            placeholder="搜订单号、工厂单号、备注"
            clearable
            @clear="search"
            @change="search"
            style="width: 300px"
            class="w400 input-with-select"
          >
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="search"
            ></el-button>
          </el-input>
          <el-button size="small" @click="pullShopifyOrders"
            >同步Shopify订单</el-button
          >
        </div>
        <div class="fr">
          <el-button size="small" @click="redirect('/orders/diy-create')"
            >作品浏览</el-button
          >
        </div>
      </div>
      <div>
        <el-table
          :data="list_data.list"
          v-loading="loading"
          style="width: 100%"
          ref="multipleTable"
          tooltip-effect="dark"
          @selection-change="handleSelectionChange"
          border
        >
          <el-table-column type="selection" width="44" :key="Math.random()"> </el-table-column>
          <el-table-column prop="order_no" label="订单号" width="155" :key="Math.random()">
            <template slot-scope="scope">
              <span
                class="pointer"
                @click="
                  redirect('/orders/detail?order_id=' + scope.row.id, true)
                "
                >{{ scope.row.order_no }}</span
              >
              <div>
                <el-tag size="mini" :type="scope.row.order_status_show.u_tag">{{
                  scope.row.order_status_show.label
                }}</el-tag>
              </div>
              <div>SPF: <a :href="'xxx'" target="_blank"> #{{scope.row.shopify_order_number}} </a> </div>

              <div style="margin-top:5px;padding-top:5px;border-top:1px dashed #ddd;">
                <p>总额：{{ scope.row.currency }} {{ scope.row.amount_total }}</p>
                <p> 运费：{{ scope.row.currency }} {{ scope.row.amount_total_logistics }} </p>
                <p> 商品：{{ scope.row.currency }} {{ scope.row.amount_total_goods }} </p>
              </div>

            </template>
          </el-table-column>
          <el-table-column prop="order_no" label="产品" width="888" :key="Math.random()">
            <template slot-scope="scope">
              <el-table
                :data="
                  scope.row.is_slide ? scope.row.detail_slide : scope.row.detail
                "
                style="width: 100%"
              >
                <el-table-column prop="sku" label="SKU" min-width="100">
                  <template slot-scope="scope2">
                    <p style="color: gray" v-if="scope2.row.diy_info">
                      {{
                        scope2.row.diy_info.designInfo.real_model_info
                          .model_name
                      }}
                      /
                      {{
                        scope2.row.diy_info.designInfo.real_model_info
                          .brand_name_en
                      }}
                    </p>
                    <!-- <p>{{ scope2.row.goods_title }}</p> -->
                    <p>{{ scope2.row.sku_code }}</p>
                    <p v-if="!scope2.row.diy_info">{{ scope2.row.model_name }}</p>
                  </template>
                </el-table-column>
                <el-table-column prop="price" label="价格" width="155">
                  <template slot-scope="scope2">
                    <p>
                      价格：{{ scope.row.currency }}
                      {{ scope2.row.price_current }}
                    </p>
                    <p>数量：x {{ scope2.row.quantity }}</p>
                  </template>
                </el-table-column>
                <el-table-column prop="order_no" label="主图" width="88">
                  <template slot-scope="scope2">
                    <el-image
                      style="width: 44px"
                      v-if="scope2.row.image"
                      :src="scope2.row.image"
                      :preview-src-list="[scope2.row.image]"
                    >
                    </el-image>
                  </template>
                </el-table-column>
                <el-table-column prop="order_no" label="LINE" width="88">
                  <template slot-scope="scope2">
                    <el-image
                      style="width: 44px"
                      v-if="scope2.row.image_sku_line"
                      :src="scope2.row.image_sku_line"
                      :preview-src-list="[scope2.row.image_sku_line]"
                    >
                    </el-image>
                  </template>
                </el-table-column>
                <el-table-column prop="mask" label="MASK" width="88">
                  <template slot-scope="scope2">
                    <el-image
                      style="width: 44px"
                      v-if="scope2.row.image_sku_mask"
                      :src="scope2.row.image_sku_mask"
                      :preview-src-list="[scope2.row.image_sku_mask]"
                    >
                    </el-image>
                  </template>
                </el-table-column>
                <el-table-column prop="order_no" label="DIY" width="88">
                  <template slot-scope="scope2">
                    <el-image
                      style="width: 44px"
                      v-if="scope2.row.image_diy"
                      :src="scope2.row.image_diy"
                      :preview-src-list="[scope2.row.image_diy]"
                    >
                    </el-image>
                  </template>
                </el-table-column>
                <el-table-column prop="order_no" label="DRAW" width="88">
                  <template slot-scope="scope2">
                    <el-image
                      style="width: 44px"
                      v-if="scope2.row.image_diy_draw"
                      :src="scope2.row.image_diy_draw"
                      :preview-src-list="[scope2.row.image_diy_draw]"
                    >
                    </el-image>
                  </template>
                </el-table-column>
                <el-table-column prop="order_no" label="PROD" width="88">
                  <template slot-scope="scope2">
                    <div
                      @click="toEditProImage(scope2.row)"
                      style="cursor: pointer"
                    >
                      <img
                        v-if="scope2.row.image_produce"
                        :src="scope2.row.image_produce"
                        style="width: 44px"
                      />
                      <i
                        v-else
                        class="el-icon-plus avatar-uploader-icon"
                        style="width: 64px; height: 64px; line-height: 64px"
                      ></i>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
              <a
                class="pointer"
                @click="scope.row.is_slide = !scope.row.is_slide"
                >{{ scope.row.is_slide ? "展开" : "收起" }} ({{
                  scope.row.detail.length
                }})</a
              >
            </template>
          </el-table-column>
          <!-- <el-table-column prop="statusShow.label" label="生产记录" width="200">
            <template slot-scope="scope">
              <div
                v-for="(produce, index_p) in scope.row.produce_record"
                :key="index_p"
              >
                <a class="pointer" @click="toPopProduce(scope.row)">{{
                  produce.factory_name
                }}</a>
                <el-tag size="mini" :type="produce.produce_status_show.u_tag">{{
                  produce.produce_status_show.label
                }}</el-tag>
              </div>
            </template>
          </el-table-column> -->
          <el-table-column prop="diy" label="上传图片" width="222" :key="Math.random()">
            <template slot-scope="scope">
              <div v-for="(item, index_d) in scope.row.diy_upload_files" :key="index_d" style="display:inline-block;">
                <el-image
                  style="width: 88px"
                  :src="item.fileOss"
                  :preview-src-list="[item.fileOss]"
                >
                </el-image>
              </div>
              <div>{{scope.row.diy_upload_form_text}}</div>
            </template>
          </el-table-column>
          <el-table-column prop="diy" label="上传作品" width="222" :key="Math.random()">
            <template slot-scope="scope">
                <el-upload class="avatar-uploader" :action=" '/order-api/v1/pub/helpers/upload-file-and-save-seller?dir_tag=diy_create&token=' + token"
                  :show-file-list="false"
                  :on-success="
                    (response, file, fileList) => {
                      return uploadDiyCreateSuccess(
                        response,
                        file,
                        fileList,
                        scope.row
                      );
                    }
                  "
                >
                <i
                  class="el-icon-plus avatar-uploader-icon"
                  style="width: 64px; height: 64px; line-height: 64px"
                ></i>
              </el-upload>
              <div v-for="(item, index_d) in scope.row.seller_diy_files" :key="index_d" style="display:inline-block;position:relative;">
                <el-image
                  style="width: 50px"
                  :src="item.fileOss"
                  :preview-src-list="[item.fileOss]"
                >
                </el-image>
                <a style="position:absolute;right:0;top:0;z-index:10;display:inline-block;width:30px;height:30px;cursor:pointer;" @click="removeDiyFile(item, scope.row)">X</a>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="order_no" label="收件人" width="300" :key="Math.random()">
            <template slot-scope="scope">
              <div>
                <div>{{ scope.row.address_info ? scope.row.address_info.city : '' }}</div>
                <div>{{ scope.row.address_info ? scope.row.address_info.country : '' }}</div>
                <p style="border:1px solid #ddd;">{{ scope.row.address_info ? scope.row.address_info.email : '' }}</p>
                <p style="border:1px solid #ddd;">{{ scope.row.address_info ? scope.row.address_info.first_name : '' }}</p>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="seller_remark" label="备注" width="300" :key="Math.random()">
            <template slot-scope="scope">
              <el-input type="textarea" v-model="scope.row.seller_remark" rows="8" @blur="saveRemark(scope.row)"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="ctime" label="订单时间" max-width="244">
            <template slot-scope="scope">
              <p>创建时间：{{ scope.row.ctime_show }}</p>
              <p v-if="scope.row.payment_time">
                付款时间：{{ scope.row.payment_time }}
              </p>
              <p v-if="scope.row.produce_submit_time">
                生产提单：{{ scope.row.produce_submit_time }}
              </p>
              <p v-if="scope.row.produce_time">
                生产完成：{{ scope.row.produce_time }}
              </p>
              <p v-if="scope.row.express_submit_time">
                提交物流{{ scope.row.express_submit_time }}
              </p>
              <p v-if="scope.row.express_time">
                发货时间：{{ scope.row.express_time }}
              </p>
              <p v-if="scope.row.receiver_time">
                收货时间：{{ scope.row.receiver_time }}
              </p>
              <p v-if="scope.row.cancel_time">
                取消时间：{{ scope.row.cancel_time }}
              </p>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="100" align="center" :key="Math.random()">
            <template slot-scope="scope">
              <el-tag size="mini" type="primary" class="pointer" @click="redirect('/orders/detail?order_id=' + scope.row.id, true)">查看详情</el-tag>
              <el-tag size="mini" type="warning" class="pointer" @click="toFlagProduce(scope.row)" v-if="scope.row.payment_time!=null">标记生产</el-tag>
              <el-tag size="mini" type="danger" class="pointer" style="margin-top:5px;" @click="toSend(scope.row)">创建物流</el-tag>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          class="my-page"
          background
          :page-size="list_data.size"
          layout="total, prev, pager, next"
          @current-change="changePage"
          :total="list_data.total"
        >
        </el-pagination>
      </div>
    </div>
    <component
      :is="popName"
      :orders="edit_row"
      :checked_orders="multipleSelection"
      :diy_info="pop_diy_info"
      :order_goods_row="edit_order_goods_row"
    ></component>
  </div>
</template>
<script>
import head from "@/pages/public/_head";
import left from "@/pages/public/_left";
const pop_drag = (resolve) => require(["@/pages/orders/_pop_drag"], resolve);
const pop_logistcs = (resolve) => require(["@/pages/logistics/_pop_edit"], resolve);
const pop_flag_produce = (resolve) => require(["@/pages/orders/_pop_flag_produce"], resolve);
// const pop_produce = (resolve) =>
//   require(["@/pages/factory/orders/_pop_produce"], resolve);
// const pop_produce_add = (resolve) =>
//   require(["@/pages/factory/orders/_pop_produce_add"], resolve);
const pop_pro_image = (resolve) =>
  require(["@/pages/orders/_pop_pro_image"], resolve);
export default {
  components: {
    "v-head": head,
    "v-left": left,
    pop_drag,
    // pop_produce,
    // pop_produce_add,
    pop_pro_image,
    pop_logistcs,
    pop_flag_produce,
  },
  data() {
    return {
      loading: false,
      popName: null,
      pop_diy_info: null,
      edit_row: null,
      edit_order_goods_row: null,
      multipleSelection: [],
      left_active: "",
      token: localStorage.getItem("token"),
      filter: {
        page: 1,
        size: 20,
        platform: "",
        keyword: "",
        status: "",
        status_type: "",
        order_type: "4",
        app_id: "",
        order_step: 2,
        time_range: [],
        order_no:"",
        shopify_order_number:"",
      },
      list_data: {
        size: 20,
        page: 1,
        total: 0,
        list: [],
      },
      order_step_options: [
        { value: 1, label: "未付款" },
        { value: 2, label: "已付款" },
        { value: 3, label: "已生产" },
        { value: 4, label: "已发货" },
        { value: 5, label: "已售后" },
        { value: 6, label: "已完成" },
        { value: 7, label: "已取消" },
      ],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
    };
  },
  methods: {
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    toEditProImage(row) {
      this.edit_order_goods_row = row;
      this.popName = "pop_pro_image";
    },
    toFlagProduce(row) { 
      this.edit_row = row;
      this.popName = "pop_flag_produce";
    },
    toSend(row) { 
      this.edit_row = row;
      this.popName = "pop_logistcs";
    },
    changePage(e) {
      this.filter.page = e;
      this.getList();
    },
    search() {
      this.filter.page = 1;
      this.getList();
    },
    toPopProduce(row) {
      this.popName = "pop_produce";
      this.edit_row = row;
    },
    toPopDrag(sub) {
      if (sub.diy_info) {
        this.popName = "pop_drag";
        this.pop_diy_info = sub.diy_info;
      }
    },
    uploadDiyCreateSuccess(res, file, fileList, row) {
      this.$http
        .post("/v1/pri/orders/save-diy-create", {
          order_id: row.id,
          file_id: res.data.id
        })
        .then((response) => {
          var res = response.data;
          if (res.code == 1) {
            this.$message({
              message: "上传成功",
              type: "success",
            });
            this.getList(false)
          } else {
            this.$message({
              message: res.msg,
              type: "warning",
            });
          }
        });
    },
    removeDiyFile(file, row) { 
      this.$confirm('删除属性', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
      }).then(() => { 
        this.$http
        .post("/v1/pri/orders/remove-diy-create", {
          order_id: row.id,
          file_id: file.id
        })
        .then((response) => {
          var res = response.data;
          if (res.code == 1) {
            this.$message({
              message: "删除成功",
              type: "success",
            });
            this.getList(false)
          } else {
            this.$message({
              message: res.msg,
              type: "warning",
            });
          }
        });
      })

    },
    exportExcel() {
      this.$http.post("/orders/export/export", this.filter).then((response) => {
        var res = response.data;
        if (res.code == 1) {
          window.location.href = res.data.file_oss;
        }
      });
    },
    pullShopifyOrders() {
      this.$http.post("/v1/pri/shopify-orders/pull-orders", this.filter).then((response) => {
        var res = response.data;
        if (res.code == 1) {
          alert("同步成功，请刷新页面")
        } else {
          this.$message({
            message: res.msg,
            type: "warning",
          });
        }
      });
    },    
    getList(is_loading = true) {
      if (is_loading) {
        this.loading = true;
      }
      this.$http.post("/v1/pri/orders/lists", this.filter).then((response) => {
        this.loading = false;
        var res = response.data;
        if (res.code == 1) {
          this.list_data = res.data;
        }
      });
    },
    saveRemark(row) {
      this.$http.post("/v1/pri/orders/save-remark", {id:row.id, content:row.seller_remark}).then((response) => {
        var res = response.data;
        if (res.code == 1) {
          this.$message({
            message: "保存成功",
            type: "success",
          });
        } else {
          this.$message({
            message: res.msg,
            type: "warning",
          });
        }
      });
    },    
    
  },
  mounted() {
    this.getList();
    var status = this.getUrlParam('status')
    if ( status == 6 ) {
      this.left_active = "paied"
    } else if ( status == 8 ) {
      this.left_active = "express"
    } else if ( status == 11 ) {
      this.left_active = "refund"
    }
  },
};
</script>
<style scoped>
.orders-page .filter-dic {
  margin-bottom: 14px;
}
</style>


// WEBPACK FOOTER //
// src/pages/orders/abandoned/Index.vue